export default __webpack_public_path__ + "static/media/icon_msgDataSource.ccfab771.svg";